import type { FC, ReactNode } from 'react';
import { Box } from '@mui/material';

import { theme } from '../../styles/theme';

interface ListContentProps {
  $isOpen: boolean;
  children: ReactNode;
}

export const ListContent: FC<ListContentProps> = ({ $isOpen, children }) => (
  <Box
    sx={{
      flex: 1,
      overflow: 'auto',
      padding: theme.spacing(4),
      paddingTop: theme.spacing(2),
      [`@media (min-width: ${theme.breakPoints.desktop}px)`]: {
        display: $isOpen ? 'block' : 'none',
      },
    }}
  >
    {children}
  </Box>
);
